'use strict'

angular
  .module('basalteApp')
  .constant('BAS_HOME_DASHBOARD', {
    EVT_HOME_DASHBOARD_UPDATED: 'evtBasHomeDashboardUpdated'
  })
